"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitRenewalChangePaymentDayPage = exports.DirectDebitRenewalChangePaymentDayPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Types_1 = require("../../Types");
var Notification_1 = require("../Notification");
var DirectDebitRenewalChangePaymentDayPagePlain = /** @class */ (function (_super) {
    __extends(DirectDebitRenewalChangePaymentDayPagePlain, _super);
    function DirectDebitRenewalChangePaymentDayPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.policyNumber = _this.props.params.number;
        _this.customerReference = _this.props.params.id;
        _this.state = {
            newPaymentDay: 0,
            showNoDaySelectedAlert: false,
            showOverlay: false,
            paymentDayOptions: [],
            proposalLoaded: false,
            renewalProposal: undefined,
        };
        _this.updatePaymentDay = _this.updatePaymentDay.bind(_this);
        _this.saveAndConfirm = _this.saveAndConfirm.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        _this.closeNoPaymentDaySelectedModal = _this.closeNoPaymentDaySelectedModal.bind(_this);
        _this.renderAlert = _this.renderAlert.bind(_this);
        return _this;
    }
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        document.title = "Change your payment day";
        this.fetchAvailablePaymentDays();
        this.supportPortalService.getRenewalProposal(this.policyNumber)
            .subscribe(function (renewalProposal) {
            _this.setState({
                renewalProposal: renewalProposal,
                proposalLoaded: true,
            });
        });
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.render = function () {
        if (this.state.proposalLoaded) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.templates.renderHeader(), this.templates.renderBackLink("Customer details", true, "/customers/".concat(this.customerReference)), (0, jsx_runtime_1.jsxs)("div", { className: "plugin", children: [this.renderPageTitle(), this.renderHeadsUpPanel(), this.renderChangePaymentDatePanel(), this.renderNavigationButtons()] }), this.templates.renderFooter(), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay }), this.renderAlert()] }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
        }
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.fetchAvailablePaymentDays = function () {
        var options = ["1st", "2nd", "3rd"];
        for (var i = 4; i <= 28; i++) {
            options.push("".concat(i, "th"));
        }
        this.setState({ paymentDayOptions: options });
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderPageTitle = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "text-group title plugin no-indent-desktop", children: (0, jsx_runtime_1.jsx)("h1", { children: "Change your payment day" }) }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderHeadsUpPanel = function () {
        return ((0, jsx_runtime_1.jsx)("p", { className: "_panel py-md-3 banner banner-info", children: "Heads up - your change will take effect in a future month and won\u2019t apply to your next payment." }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderChangePaymentDatePanel = function () {
        var _a;
        return ((0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "changePaymentDayQuestion", children: "Which day of the month should we take your payment?" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsx)("select", { id: "changePaymentDayQuestion", className: "form-control", onChange: this.updatePaymentDay, value: this.state.newPaymentDay, disabled: !this.state.paymentDayOptions || ((_a = this.state.paymentDayOptions) === null || _a === void 0 ? void 0 : _a.length) === 0, children: this.renderPaymentDayOptions() }) })] }) }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.updatePaymentDay = function (event) {
        var selectedDate = parseInt(event.target.value, 10);
        this.setState({ newPaymentDay: selectedDate });
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderPaymentDayOptions = function () {
        if (!this.state.paymentDayOptions) {
            return (0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." });
        }
        var index = 0;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." }), this.state.paymentDayOptions.map(function (option) {
                    return ((0, jsx_runtime_1.jsx)("option", { className: option, value: ++index, children: option }, index));
                })] }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderNavigationButtons = function () {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-white-dashboard margin-y40", onClick: this.cancelChanges, children: "Cancel" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-primary float-right", onClick: this.saveAndConfirm, disabled: !this.state.paymentDayOptions || ((_a = this.state.paymentDayOptions) === null || _a === void 0 ? void 0 : _a.length) === 0, children: "Save and confirm" })] }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.saveAndConfirm = function () {
        var _this = this;
        var allowedPaymentDay = this.state.newPaymentDay !== 0;
        this.setState({
            showOverlay: true
        });
        if (allowedPaymentDay) {
            this.supportPortalService.storeAnnualToMonthlyPaymentDay(this.customerReference, this.policyNumber, this.state.newPaymentDay).subscribe(function () {
                _this.setState({
                    showNoDaySelectedAlert: false
                });
                _this.props.navigate("/customers/".concat(_this.customerReference));
            });
        }
        else {
            this.setState({
                showNoDaySelectedAlert: true,
                showOverlay: false
            });
        }
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.cancelChanges = function () {
        this.props.navigate("/customers/".concat(this.customerReference));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.renderAlert = function () {
        return ((0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showNoDaySelectedAlert, hide: this.closeNoPaymentDaySelectedModal, title: "Warning!", message: "Please select a payment date to continue." }));
    };
    DirectDebitRenewalChangePaymentDayPagePlain.prototype.closeNoPaymentDaySelectedModal = function () {
        this.setState(function (prevState) { return ({
            showNoDaySelectedAlert: !prevState.showNoDaySelectedAlert
        }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DirectDebitRenewalChangePaymentDayPagePlain.prototype, "supportPortalService", void 0);
    DirectDebitRenewalChangePaymentDayPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DirectDebitRenewalChangePaymentDayPagePlain);
    return DirectDebitRenewalChangePaymentDayPagePlain;
}(React.Component));
exports.DirectDebitRenewalChangePaymentDayPagePlain = DirectDebitRenewalChangePaymentDayPagePlain;
exports.DirectDebitRenewalChangePaymentDayPage = (0, components_1.withRouter)(DirectDebitRenewalChangePaymentDayPagePlain);
//# sourceMappingURL=DirectDebitRenewalChangePaymentDayPage.js.map